import { render, staticRenderFns } from "./hexiaomingxi.vue?vue&type=template&id=4a7c096e&"
import script from "./hexiaomingxi.vue?vue&type=script&lang=js&"
export * from "./hexiaomingxi.vue?vue&type=script&lang=js&"
import style0 from "./hexiaomingxi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports